import { ModuleLayout, NavigationItem } from '@/components/ModuleLayout'
import {
  LayoutDashboard,
  Banknote,
  Building2,
  Wallet,
  LineChart,
  CreditCard,
  ClipboardCheck,
  ArrowLeftRight,
  Landmark,
  BookOpen,
  FileText,
  Send,
} from 'lucide-react'
import { ShortcutProvider } from '@/contexts/ShortcutContext'
import { ShortcutHelpOverlay } from '@/components/ui/shortcut-help-overlay'
import { ShortcutFooterBar } from '@/components/ui/shortcut-footer-bar'

const navigation: NavigationItem[] = [
  {
    name: 'Panel Principal',
    href: '/treasury/dashboard',
    icon: LayoutDashboard,
  },
  {
    name: 'Movimientos de Caja',
    href: '/treasury/cash-movements',
    icon: Banknote,
  },
  {
    name: 'Cuentas Bancarias',
    href: '/treasury/bank-accounts',
    icon: Building2,
  },
  {
    name: 'Billeteras Virtuales',
    href: '/treasury/wallets',
    icon: Wallet,
  },
  {
    name: 'Cuentas de Inversión',
    href: '/treasury/investments',
    icon: LineChart,
  },
  {
    name: 'Cobro Online',
    href: '/treasury/online-payments',
    icon: CreditCard,
  },
  {
    name: 'Cierre de Mercado Pago',
    href: '/treasury/cierre-mercadopago',
    icon: ClipboardCheck,
  },
  {
    name: 'Liquidaciones',
    href: '/treasury/settlements',
    icon: ArrowLeftRight,
  },
  {
    name: 'Subdiario de Caja',
    href: '/treasury/subdiario',
    icon: BookOpen,
  },
  {
    name: 'Submayores',
    href: '/treasury/submayores',
    icon: FileText,
  },
  {
    name: 'Pase al Diario',
    href: '/treasury/pase-diario',
    icon: Send,
  },
]

export function TreasuryLayout({ children }: { children: React.ReactNode }) {
  return (
    <ShortcutProvider>
      <ModuleLayout
        moduleName="Tesorería"
        moduleIcon={Landmark}
        moduleColor="from-emerald-500 to-emerald-600"
        navigation={navigation}
        footer={<ShortcutFooterBar />}
      >
        {children}
      </ModuleLayout>
      <ShortcutHelpOverlay />
    </ShortcutProvider>
  )
}
